import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem1,
    GridItem4,
    GridItem5,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    DivOverflowXTabelaPadrao,
} from '../../../business-components/Div/Div'

import {
    CardGridEstudo,
    CardGridDivider,
} from '../../../business-components/Card/Card'

import {
    SvgIconSucessaoVitalicia,
} from '../../../business-components/SvgIcon/SvgIconEstudo/SvgIconEstudo'

import {
    formataReportTitulo,
    formataReportTituloDestaque,
    formataReportSubTitulo,
    formataReportValor,
    formataReportValorTotal,
    formataReportValorSubTotal,
    formataReportPerc,
    formataReportPercDestaque,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoPadrao,
    CardGridEstudoPadraoMd,
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'

import EstudoFormComposicaoInventario from './EstudoFormComposicaoInventario'



const EstudoFormSucessaoVitalicia = ({ values, estudo, report/*, jsonConfiguracao*/, simulacaoFinanceira,
    gestaoPatrimonial }) => {

    const SucessaoVitaliciaCabecalho = () => {

        return (
            <GridContainer
                className='mt-2 mb-1'//mb-2//'mt-5 mb-2'
            >
                <GridItem12>
                    <GridContainer>
                        <GridItem6/>

                        <GridItem6>
                            <GridContainer>
                                <GridItem4
                                    //align='left' // mudança fonte: 'right'
                                    align='right' // mudança fonte: 'right'
                                >
                                    {formataReportTituloDestaque(LABEL.total)}
                                </GridItem4>

                                {dadosCompletosCliente(values) && (
                                    <GridItem4
                                        //align='left' // mudança fonte: 'right'
                                        align='right' // mudança fonte: 'right'
                                    >
                                        {formataReportTituloDestaque(tituloCliente(values))}
                                    </GridItem4>
                                )}

                                {dadosCompletosConjuge(values) && (
                                    <GridItem4
                                        //align='left' // mudança fonte: 'right'
                                        align='right' // mudança fonte: 'right'
                                    >
                                        {formataReportTituloDestaque(tituloConjuge(values))}
                                    </GridItem4>
                                )}
                            </GridContainer>
                        </GridItem6>
                    </GridContainer>
                </GridItem12>
            </GridContainer>
        )
    }

    const SucessaoVitaliciaItem = ( {titulo, subTitulo, valorTotal, valorCliente, valorConjuge, destaque, destaqueTotal,
        destaqueSemBg } ) => {
        
        return (
            <GridContainer
                className={
                    destaqueSemBg
                        ?
                            ''
                        :
                            destaqueTotal
                                ?
                                    'bg-cardGridDivBodyResumoTotalGeral'
                                : 
                                    destaque
                                        ?
                                            'bg-cardGridDivBodyResumoTotal mb-2'
                                        :
                                            ''
                }
            >
                <GridItem12
                    className='mb--1'//mb--0
                >
                    <GridContainer>
                        {subTitulo
                            ?
                                <>
                                    <GridItem5>
                                        {destaque ? formataReportTituloDestaque(titulo) : formataReportTitulo(titulo)}
                                    </GridItem5>
                        
                                    <GridItem1
                                        className={destaque ? 'mt-1' : ''}
                                        align='left' // mudança fonte: 'center'
                                    >
                                        {destaque ? formataReportPercDestaque(subTitulo) : formataReportPerc(subTitulo)}
                                    </GridItem1>
                                </>
                            :
                                <GridItem6>
                                    {destaque ? formataReportTituloDestaque(titulo) : formataReportTitulo(titulo)}
                                </GridItem6>
                        }

                        <GridItem6
                            className={destaque ? 'mt-1' : ''}
                        >
                            <GridContainer>
                                <GridItem4
                                    //align='left' // mudança fonte: 'right'
                                    align='right' // mudança fonte: 'right'
                                >
                                    {destaque ? formataReportValorTotal(valorTotal) : formataReportValor(valorTotal)}
                                </GridItem4>

                                {dadosCompletosCliente(values) && (
                                    <GridItem4
                                        //align='left' // mudança fonte: 'right'
                                        align='right' // mudança fonte: 'right'
                                    >
                                        {destaque ? formataReportValorTotal(valorCliente) : formataReportValor(valorCliente)}
                                    </GridItem4>
                                )}

                                {dadosCompletosConjuge(values) && (
                                    <GridItem4
                                        //align='left' // mudança fonte: 'right'
                                        align='right' // mudança fonte: 'right'
                                    >
                                        {destaque ? formataReportValorTotal(valorConjuge) : formataReportValor(valorConjuge)}
                                    </GridItem4>
                                )}
                            </GridContainer>
                        </GridItem6>
                    </GridContainer>
                </GridItem12>
            </GridContainer>
        )
    }

    const SucessaoVitaliciaOpcoesAporte = ( {className, titulo, tituloBoldPreto, subTitulo, classNameTitulo, valorTotal, valorCliente, valorConjuge } ) => {

        return (
            <GridContainer>
                <GridItem12
                    className={className}
                >
                    <GridContainer>
                        {subTitulo
                            ?
                                <>
                                    <GridItem5
                                        className={'mt-0'}
                                    >
                                        <span
                                            className={classNameTitulo}
                                        >
                                            {formataReportSubTitulo(titulo, tituloBoldPreto)}
                                        </span>
                                    </GridItem5>
                        
                                    <GridItem1
                                        className={'mt-0'}
                                        align='center'
                                    >
                                        {formataReportPerc(subTitulo)}
                                    </GridItem1>
                                </>
                            :
                                <GridItem6
                                    className={'mt-0'}
                                >
                                    <span
                                        className={classNameTitulo}
                                    >
                                        {formataReportSubTitulo(titulo, tituloBoldPreto)}
                                    </span>
                                </GridItem6>
                        }

                        <GridItem6
                            className={'mb-0'} //mb-1
                        >
                            <GridContainer>
                                <GridItem4
                                    //align='left' // mudança fonte: 'right'
                                    align='right' // mudança fonte: 'right'
                                >
                                    {formataReportValorSubTotal(valorTotal)}
                                </GridItem4>

                                {dadosCompletosCliente(values) && (
                                    <GridItem4
                                        //align='left' // mudança fonte: 'right'
                                        align='right' // mudança fonte: 'right'
                                    >
                                        {formataReportValorSubTotal(valorCliente)}
                                    </GridItem4>
                                )}

                                {dadosCompletosConjuge(values) && (
                                    <GridItem4
                                        //align='left' // mudança fonte: 'right'
                                        align='right' // mudança fonte: 'right'
                                    >
                                        {formataReportValorSubTotal(valorConjuge)}
                                    </GridItem4>
                                )}
                            </GridContainer>
                        </GridItem6>
                    </GridContainer>
                </GridItem12>
            </GridContainer>
        )
    }

    const DivSucessaoVitalicia = () => {

        return (
            <div
                className='mb-6'//mb-7
            />
        )
    }

    const SucessaoVitalicia = (/*props*/) => {
        
        return (
            //<div
            //    {...props}
            //>
            <>
                <SucessaoVitaliciaCabecalho/>

                <SucessaoVitaliciaItem
                    titulo={LABEL.ativosInventariar}
                    subTitulo={''}
                    valorTotal={values.sucessaoVitaliciaTotalGeral.valorPatrimonioImobilizado +
                        values.sucessaoVitaliciaTotalGeral.valorRecursosFinanceiros
                    }
                    valorCliente={values.sucessaoVitaliciaTotalGeral.valorClientePatrimonioImobilizado +
                        values.sucessaoVitaliciaTotalGeral.valorClienteRecursosFinanceiros
                    }
                    valorConjuge={values.sucessaoVitaliciaTotalGeral.valorConjugePatrimonioImobilizado +
                        values.sucessaoVitaliciaTotalGeral.valorConjugeRecursosFinanceiros
                    }
                    destaque={true}
                />

                <SucessaoVitaliciaItem
                    titulo={LABEL.patrimonioImobilizado}
                    subTitulo={''}
                    valorTotal={values.sucessaoVitaliciaTotalGeral.valorPatrimonioImobilizado}
                    valorCliente={values.sucessaoVitaliciaTotalGeral.valorClientePatrimonioImobilizado}
                    valorConjuge={values.sucessaoVitaliciaTotalGeral.valorConjugePatrimonioImobilizado}
                    destaque={false}
                />

                <SucessaoVitaliciaItem
                    titulo={LABEL.recursosFinanceiros}
                    subTitulo={''}
                    valorTotal={values.sucessaoVitaliciaTotalGeral.valorRecursosFinanceiros}
                    valorCliente={values.sucessaoVitaliciaTotalGeral.valorClienteRecursosFinanceiros}
                    valorConjuge={values.sucessaoVitaliciaTotalGeral.valorConjugeRecursosFinanceiros}
                    destaque={false}
                />

                <DivSucessaoVitalicia/>

                <SucessaoVitaliciaItem
                    titulo={LABEL.inventario.toUpperCase() /* mudança da fonte: uppercase */}
                    subTitulo={''}
                    valorTotal={values.inventarioCliente + values.inventarioConjuge}
                    valorCliente={values.inventarioCliente}
                    valorConjuge={values.inventarioConjuge}
                    destaque={true}
                />

                <SucessaoVitaliciaItem
                    titulo={LABEL.despesasAdvocaticias}
                    subTitulo={/*values.percDespesasAdvocaticias*/
                        values.sucessaoVitaliciaTotalGeral.valorInventarioDespesasAdvocaticias /
                            (values.sucessaoVitaliciaTotalGeral.valorPatrimonioImobilizado +
                                values.sucessaoVitaliciaTotalGeral.valorRecursosFinanceirosDespesasAdvocaticiasCustasJudiciais
                            ) * 100
                    }
                    valorTotal={values.sucessaoVitaliciaTotalGeral.valorInventarioDespesasAdvocaticias}
                    valorCliente={values.sucessaoVitaliciaTotalGeral.valorInventarioDespesasAdvocaticiasCliente}
                    valorConjuge={values.sucessaoVitaliciaTotalGeral.valorInventarioDespesasAdvocaticiasConjuge}
                />
                
                <SucessaoVitaliciaItem
                    titulo={LABEL.custasJudiciais}
                    subTitulo={/*values.percCustasJudiciais*/
                        values.sucessaoVitaliciaTotalGeral.valorInventarioCustasJudiciais /
                            (values.sucessaoVitaliciaTotalGeral.valorPatrimonioImobilizado +
                                values.sucessaoVitaliciaTotalGeral.valorRecursosFinanceirosDespesasAdvocaticiasCustasJudiciais
                            ) * 100
                    }
                    valorTotal={values.sucessaoVitaliciaTotalGeral.valorInventarioCustasJudiciais}
                    valorCliente={values.sucessaoVitaliciaTotalGeral.valorInventarioCustasJudiciaisCliente}
                    valorConjuge={values.sucessaoVitaliciaTotalGeral.valorInventarioCustasJudiciaisConjuge}
                    destaque={false}
                />

                <SucessaoVitaliciaItem
                    titulo={LABEL.itcmd}
                    subTitulo={
                        values.sucessaoVitaliciaTotalGeral.valorInventarioItcmd /
                            (values.sucessaoVitaliciaTotalGeral.valorPatrimonioImobilizado +
                                values.sucessaoVitaliciaTotalGeral.valorRecursosFinanceiros
                            ) * 100
                    }
                    valorTotal={values.sucessaoVitaliciaTotalGeral.valorInventarioItcmd}
                    valorCliente={values.sucessaoVitaliciaTotalGeral.valorInventarioItcmdCliente}
                    valorConjuge={values.sucessaoVitaliciaTotalGeral.valorInventarioItcmdConjuge}
                    destaque={false}
                />

                <DivSucessaoVitalicia/>

                {values.emergencial !== 0
                    ?
                        <>
                            <SucessaoVitaliciaItem
                                titulo={LABEL.emergencial}
                                subTitulo={''}
                                valorTotal={values.emergencial}
                                valorCliente={round(values.emergencialCliente, 2)}
                                valorConjuge={round(values.emergencialConjuge, 2)}
                                destaque={true}
                            />

                            <DivSucessaoVitalicia/>
                        </>
                    :
                        ''
                }
                
                <SucessaoVitaliciaItem
                    titulo={LABEL.sucessaoVitalicia.toUpperCase() /* mudança da fonte: uppercase */}
                    subTitulo={
                        //(values.sucessaoVitaliciaCliente + values.sucessaoVitaliciaConjuge) /
                        //    (values.sucessaoVitaliciaTotalGeral.valorPatrimonioImobilizado +
                        //        values.sucessaoVitaliciaTotalGeral.valorRecursosFinanceiros
                        //    ) * 100
                        (values.sucessaoVitaliciaTotalGeral.valorInventarioDespesasAdvocaticias /
                            (values.sucessaoVitaliciaTotalGeral.valorPatrimonioImobilizado +
                                values.sucessaoVitaliciaTotalGeral.valorRecursosFinanceirosDespesasAdvocaticiasCustasJudiciais
                            ) * 100) +
                        (values.sucessaoVitaliciaTotalGeral.valorInventarioCustasJudiciais /
                            (values.sucessaoVitaliciaTotalGeral.valorPatrimonioImobilizado +
                                values.sucessaoVitaliciaTotalGeral.valorRecursosFinanceirosDespesasAdvocaticiasCustasJudiciais
                            ) * 100) + 
                        (values.sucessaoVitaliciaTotalGeral.valorInventarioItcmd /
                            (values.sucessaoVitaliciaTotalGeral.valorPatrimonioImobilizado +
                                values.sucessaoVitaliciaTotalGeral.valorRecursosFinanceiros
                            ) * 100)
                    }
                    valorTotal={values.sucessaoVitaliciaCliente + values.sucessaoVitaliciaConjuge}
                    valorCliente={values.sucessaoVitaliciaCliente}
                    valorConjuge={values.sucessaoVitaliciaConjuge}
                    destaque={true}
                    destaqueTotal={true}
                />

                {!values.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia &&
                values.valorCSVidaInteiraApoliceCliente + values.valorCSVidaInteiraApoliceConjuge > 0 && (
                    <div
                        className='mt-5'
                    >
                        <SucessaoVitaliciaItem
                            titulo={LABEL.valorCSAtual}
                            subTitulo={''}
                            valorTotal={values.valorCSVidaInteiraApoliceCliente + values.valorCSVidaInteiraApoliceConjuge}
                            valorCliente={values.valorCSVidaInteiraApoliceCliente}
                            valorConjuge={values.valorCSVidaInteiraApoliceConjuge}
                            destaque={false}
                        />

                        <div
                            className='mt-5'
                        >
                            <SucessaoVitaliciaItem
                                titulo={LABEL.necessidade.toUpperCase() /* mudança da fonte: uppercase */}
                                subTitulo={''}
                                valorTotal={
                                    values.sucessaoVitaliciaCliente + values.sucessaoVitaliciaConjuge -
                                        values.valorCSVidaInteiraApoliceCliente - values.valorCSVidaInteiraApoliceConjuge
                                }
                                valorCliente={
                                    values.sucessaoVitaliciaCliente - values.valorCSVidaInteiraApoliceCliente
                                }
                                valorConjuge={
                                    values.sucessaoVitaliciaConjuge - values.valorCSVidaInteiraApoliceConjuge
                                }
                                destaque={true}
                                destaqueTotal={true}
                            />
                        </div>
                    </div>
                )}

                {values.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia && (
                    <div
                        className='mt-5'
                    >
                        <SucessaoVitaliciaItem
                            titulo={LABEL.previdenciaPrivada}
                            subTitulo={''}
                            valorTotal={values.valorPrevidenciaPrivadaCliente + values.valorPrevidenciaPrivadaConjuge}
                            valorCliente={values.valorPrevidenciaPrivadaCliente}
                            valorConjuge={values.valorPrevidenciaPrivadaConjuge}
                            destaque={false}
                        />

                        <SucessaoVitaliciaItem
                            titulo={LABEL.valorCSAtual}
                            subTitulo={''}
                            valorTotal={values.valorCSVidaInteiraApoliceCliente + values.valorCSVidaInteiraApoliceConjuge}
                            valorCliente={values.valorCSVidaInteiraApoliceCliente}
                            valorConjuge={values.valorCSVidaInteiraApoliceConjuge}
                            destaque={false}
                        />

                        <div
                            className='mt-5'
                        >
                            <SucessaoVitaliciaItem
                                titulo={LABEL.necessidade.toUpperCase() /* mudança da fonte: uppercase */}
                                subTitulo={''}
                                valorTotal={
                                    values.sucessaoVitaliciaCliente + values.sucessaoVitaliciaConjuge -
                                        values.valorPrevidenciaPrivadaCliente - values.valorPrevidenciaPrivadaConjuge -
                                            values.valorCSVidaInteiraApoliceCliente -
                                                values.valorCSVidaInteiraApoliceConjuge
                                }
                                valorCliente={
                                    values.sucessaoVitaliciaCliente -
                                        values.valorPrevidenciaPrivadaCliente - 
                                            values.valorCSVidaInteiraApoliceCliente
                                }
                                valorConjuge={
                                    values.sucessaoVitaliciaConjuge -
                                        values.valorPrevidenciaPrivadaConjuge -
                                            values.valorCSVidaInteiraApoliceConjuge
                                }
                                destaque={true}
                                destaqueTotal={true}
                            />
                        </div>
                    </div>
                )}

                {!values.incluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia &&
                existeTabelaEvolucaoValorResgate(values) && (
                    <>
                        <DivSucessaoVitalicia/>

                        <SucessaoVitaliciaItem
                            titulo={LABEL.premioAnualPercCarteira.toUpperCase() /* mudança da fonte: uppercase */}
                            subTitulo={
                                values.sucessaoVitaliciaTotalGeral.valorClienteRecursosFinanceiros +
                                    values.sucessaoVitaliciaTotalGeral.valorConjugeRecursosFinanceiros === 0
                                        ?
                                            ''
                                        :
                                            (values.valorPremioAnualizadoVidaInteiraCliente +
                                                values.valorPremioAnualizadoVidaInteiraConjuge
                                            ) /
                                            (estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoRecursosFinanceiros].valorAcumuladoPainel
                                            /*values.sucessaoVitaliciaTotalGeral.valorClienteRecursosFinanceiros +
                                                values.sucessaoVitaliciaTotalGeral.valorConjugeRecursosFinanceiros*/
                                            ) * 100
                            }
                            classNameTitulo={'ml-10'}
                            valorTotal={values.valorPremioAnualizadoVidaInteiraCliente +
                                values.valorPremioAnualizadoVidaInteiraConjuge
                            }
                            valorCliente={values.valorPremioAnualizadoVidaInteiraCliente}
                            valorConjuge={values.valorPremioAnualizadoVidaInteiraConjuge}
                            destaque={true}
                            destaqueSemBg={true}
                        />
                    </>
                )}

                {values.incluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia && (
                    <div
                        className={'mt-10'}
                    >
                        <h3>
                            {
                                existeTabelaEvolucaoValorResgate(values)
                                    ?
                                        LABEL.sucessaoVitaliciaOpcoesAporteImediato
                                    :
                                        LABEL.sucessaoVitaliciaOpcoes
                            }
                        </h3>
                
                        <CardGridDivider
                            className='mb-4'
                        />

                        <SucessaoVitaliciaCabecalho/>

                        <SucessaoVitaliciaOpcoesAporte
                            titulo={LABEL.previdenciaPrivada.toUpperCase() /* mudança da fonte: uppercase */}
                            tituloBoldPreto={true} // mudança da fonte
                            classNameTitulo={''}
                            valorTotal={''}
                            valorCliente={''}
                            valorConjuge={''}
                        />

                        <SucessaoVitaliciaOpcoesAporte
                            className={'mt-2'}
                            titulo={LABEL.necessidade}
                            subTitulo={
                                (values.sucessaoVitaliciaCliente +
                                    values.sucessaoVitaliciaConjuge
                                ) /
                                (estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoRecursosFinanceiros].valorAcumuladoPainel
                                /*values.sucessaoVitaliciaTotalGeral.valorClienteRecursosFinanceiros +
                                    values.sucessaoVitaliciaTotalGeral.valorConjugeRecursosFinanceiros*/
                                ) * 100
                            }
                            classNameTitulo={'ml-10'}
                            valorTotal={values.sucessaoVitaliciaCliente + values.sucessaoVitaliciaConjuge}
                            valorCliente={values.sucessaoVitaliciaCliente}
                            valorConjuge={values.sucessaoVitaliciaConjuge}
                        />

                        <SucessaoVitaliciaOpcoesAporte
                            titulo={LABEL.saldoAtual}
                            classNameTitulo={'ml-10'}
                            valorTotal={values.valorPrevidenciaPrivadaCliente + values.valorPrevidenciaPrivadaConjuge}
                            valorCliente={values.valorPrevidenciaPrivadaCliente}
                            valorConjuge={values.valorPrevidenciaPrivadaConjuge}
                        />

                        {!existeTabelaEvolucaoValorResgate(values) && (
                            <SucessaoVitaliciaOpcoesAporte
                                titulo={LABEL.aporteComplementar}
                                classNameTitulo={'ml-10'}
                                valorTotal={values.sucessaoVitaliciaCliente + values.sucessaoVitaliciaConjuge -
                                    values.valorPrevidenciaPrivadaCliente - values.valorPrevidenciaPrivadaConjuge
                                }
                                valorCliente={
                                    values.sucessaoVitaliciaCliente > values.valorPrevidenciaPrivadaCliente
                                        ?
                                            values.sucessaoVitaliciaCliente - values.valorPrevidenciaPrivadaCliente
                                        :
                                            0
                                }
                                valorConjuge={
                                    values.sucessaoVitaliciaConjuge > values.valorPrevidenciaPrivadaConjuge
                                        ?
                                            values.sucessaoVitaliciaConjuge - values.valorPrevidenciaPrivadaConjuge
                                        :
                                            0
                                }
                            />
                        )}

                        <SucessaoVitaliciaOpcoesAporte
                            className={'mt-2'}
                            titulo={LABEL.seguroVida.toUpperCase() /* mudança da fonte: uppercase */}
                            tituloBoldPreto={true} // mudança da fonte
                            classNameTitulo={''}
                            valorTotal={''}
                            valorCliente={''}
                            valorConjuge={''}
                        />

                        {existeTabelaEvolucaoValorResgate(values) && (
                            <>
                                <SucessaoVitaliciaOpcoesAporte
                                    className={'mt-3'}
                                    titulo={LABEL.premioAnual}
                                    subTitulo={
                                        (values.valorPremioAnualizadoVidaInteiraCliente +
                                            values.valorPremioAnualizadoVidaInteiraConjuge
                                        ) /
                                        (estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoRecursosFinanceiros].valorAcumuladoPainel
                                        /*values.sucessaoVitaliciaTotalGeral.valorClienteRecursosFinanceiros +
                                            values.sucessaoVitaliciaTotalGeral.valorConjugeRecursosFinanceiros*/
                                        ) * 100
                                    }
                                    classNameTitulo={'ml-10'}
                                    valorTotal={values.valorPremioAnualizadoVidaInteiraCliente +
                                        values.valorPremioAnualizadoVidaInteiraConjuge
                                    }
                                    valorCliente={values.valorPremioAnualizadoVidaInteiraCliente}
                                    valorConjuge={values.valorPremioAnualizadoVidaInteiraConjuge}
                                />

                                <SucessaoVitaliciaOpcoesAporte
                                    titulo={LABEL.valorCS}
                                    classNameTitulo={'ml-10'}
                                    valorTotal={values.valorCSVidaInteiraCotacaoCliente + values.valorCSVidaInteiraCotacaoConjuge}
                                    valorCliente={values.valorCSVidaInteiraCotacaoCliente}
                                    valorConjuge={values.valorCSVidaInteiraCotacaoConjuge}
                                />
                            </>
                        )}

                        {!existeTabelaEvolucaoValorResgate(values) && (
                            <>
                                 <SucessaoVitaliciaOpcoesAporte
                                    className={'mt-3'}
                                    titulo={LABEL.necessidade}
                                    classNameTitulo={'ml-10'}
                                    valorTotal={values.sucessaoVitaliciaCliente + values.sucessaoVitaliciaConjuge}
                                    valorCliente={values.sucessaoVitaliciaCliente}
                                    valorConjuge={values.sucessaoVitaliciaConjuge}
                                />

                                <SucessaoVitaliciaOpcoesAporte
                                    titulo={LABEL.valorCSAtual}
                                    classNameTitulo={'ml-10'}
                                    valorTotal={values.valorCSVidaInteiraCotacaoCliente + values.valorCSVidaInteiraCotacaoConjuge}
                                    valorCliente={values.valorCSVidaInteiraCotacaoCliente}
                                    valorConjuge={values.valorCSVidaInteiraCotacaoConjuge}
                                />

                                <SucessaoVitaliciaOpcoesAporte
                                    titulo={LABEL.valorCSComplementar}
                                    classNameTitulo={'ml-10'}
                                    valorTotal={values.sucessaoVitaliciaCliente + values.sucessaoVitaliciaConjuge -
                                        values.valorCSVidaInteiraCotacaoCliente + values.valorCSVidaInteiraCotacaoConjuge
                                    }
                                    valorCliente={
                                        values.sucessaoVitaliciaCliente > values.valorCSVidaInteiraCotacaoCliente
                                            ?
                                                values.sucessaoVitaliciaCliente - values.valorCSVidaInteiraCotacaoCliente
                                            :
                                                0
                                    }
                                    valorConjuge={
                                        values.sucessaoVitaliciaConjuge > values.valorCSVidaInteiraCotacaoConjuge
                                            ?
                                                values.sucessaoVitaliciaConjuge - values.valorCSVidaInteiraCotacaoConjuge
                                            :
                                                0
                                    }
                                />
                            </>
                        )}
                    </div>
                )}
            </>
            //</div>
        )
    }

    const CardGridEstudoPadraoAux = simulacaoFinanceira ? CardGridEstudoPadrao : CardGridEstudoPadraoMd



    return (
         <GridItem12>
            {report
                ?
                    <div
                        className='mt--4'
                    >
                    <SucessaoVitalicia
                        //className='ml-3 mr-3 mt--5' // mudança da fonte: sem mt
                    />
                    </div>
                :
                    gestaoPatrimonial
                        ?
                            <CardGridEstudo>
                                <CardGridEstudoTabelaPadrao
                                    values={values}
                                    SvgIcon={SvgIconSucessaoVitalicia}
                                    label={LABEL.sucessaoVitalicia}
                                    helpTextMorte={""}
                                    helpTextInvalidez={""}
                                    component={
                                        <SucessaoVitalicia/>
                                    }
                                    popup={false}
                                />
                            </CardGridEstudo>
                        :
                            <CardGridEstudoPadraoAux
                                label={
                                    !relatorioModoApresentacao(values)
                                        ?
                                            LABEL.sucessaoVitalicia
                                        :
                                            HARDCODE.modoApresentacaoRelatorio
                                }
                                component={
                                    <DivOverflowXTabelaPadrao>
                                        <SucessaoVitalicia/>
                                    </DivOverflowXTabelaPadrao>
                                }
                                overflowX={false}
                                detalhesCalculo={
                                    <EstudoFormComposicaoInventario
                                        values={values}
                                        estudo={estudo}
                                        popup={true}
                                    />
                                }
                                modoApresentacao={values.modoApresentacao}
                            />
            }
        </GridItem12>
    )
}

export default EstudoFormSucessaoVitalicia